import * as ActionType from '../actions/image-zoom-popup';

const defaultState = {isZoomPopupClosed: true, image: null};

/**
 * @description
 * Modal rules
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function imageZoomPopup (state = defaultState, action) {
	let newState = {...state};

	switch (action.type) {

		case ActionType.DEACTIVATE_ZOOM_POPUP : {
			newState.isZoomPopupClosed = true;
			newState.image = null;
			return newState;
		}

		case ActionType.ACTIVATE_ZOOM_POPUP : {
			newState.isZoomPopupClosed = false;
			newState.image = action.image;
			return newState;
		}

		default:
			return state;
	}
}
